"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleRequiredField = void 0;
const handleRequiredField = ({ value, name, options, context }) => {
    if (options.required) {
        if (value) {
            context.actions?.clearError(name);
            return true;
        }
        context.actions?.setError(name, { message: options.required.message });
        return false;
    }
    return true;
};
exports.handleRequiredField = handleRequiredField;
